import { useEffect } from "react";
import { hasOpenOverlay, hasTransientPopupOpen } from "@/hooks/useOverlayDismiss";
import { shouldHandleAppChord } from "@/lib/keyboardShortcuts";

/**
 * Opens My Tasks on `t` when focus is not in a typing control.
 * Does not fire while overlays, menus, or go-nav mode are active so `a` then `t`
 * still creates a task from the Add menu.
 */
export default function useOpenTasksShortcut({
  onOpenTasks,
  enabled = true
}: {
  onOpenTasks?: () => void;
  enabled?: boolean;
}) {
  useEffect(() => {
    if (!enabled || !onOpenTasks) return;

    const handleKeyDown = (event: KeyboardEvent) => {
      if (!shouldHandleAppChord(event)) return;
      if (event.key.toLowerCase() !== "t") return;
      if (hasOpenOverlay() || hasTransientPopupOpen()) return;
      if (document.body.dataset.goNavMode === "true") return;

      event.preventDefault();
      onOpenTasks();
    };

    document.addEventListener("keydown", handleKeyDown, true);
    return () => document.removeEventListener("keydown", handleKeyDown, true);
  }, [enabled, onOpenTasks]);
}
